import React, { useState, useEffect } from 'react';

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Sathurkha Thiyagaraja',
      rating: 5,
      date: '2 weeks ago',
      text: 'Really worth the money and they are very friendly when contacting. Love the product and service. Trustworthy.',
    },
    {
      id: 2,
      name: 'Ziyadh Zunuzi',
      rating: 5,
      date: '44 weeks ago',
      text: 'Highly recommended. I ordered a night lamp for my husband and it was awesome, amazing, fantastic, and creative. Worth the price and supported by friendly customer service.',
    },
    {
      id: 3,
      name: 'Nelma',
      rating: 5,
      date: '27 Dec 2022',
      text: 'I ordered a customized Christmas ornament last minute and it turned out better than expected. They are super friendly and supportive.',
    },
    {
      id: 4,
      name: 'Uditha Silva',
      rating: 5,
      date: '8 Sept 2022',
      text: 'We ordered a night lamp and the overall experience was excellent. I would definitely recommend Merch Masters LK for unique and memorable gifts.',
    },
    {
      id: 5,
      name: 'Nilakshi Wickramathilaka',
      rating: 5,
      date: '9 Aug 2022',
      text: 'Highly recommend. They handled my urgent order and delivered a beautiful result. Thank you so much for the lovely art.',
    },
    {
      id: 6,
      name: 'Dilusha Gunasekera',
      rating: 5,
      date: '7 Aug 2022',
      text: 'Highly recommended. Very happy with the product. Quick and beautiful work.',
    },
    {
      id: 7,
      name: 'Anu',
      rating: 5,
      date: '25 Jul 2022',
      text: 'Great customer service. Super fast and amazing product. My friend loved the wedding gift. Highly recommended.',
    },
    {
      id: 8,
      name: 'Nayanajith Chathushka Rathnayake',
      rating: 5,
      date: '12 Feb 2022',
      text: 'Very friendly, on-time delivery, and perfect quality work just as requested. Recommended.',
    },
    {
      id: 9,
      name: 'Kastona K. Manokarathas',
      rating: 5,
      date: '3 Feb 2022',
      text: 'Exactly the same as the picture I received from your shop.',
    },
    {
      id: 10,
      name: 'Subi Tshan',
      rating: 5,
      date: '25 Jan 2022',
      text: 'Useful and memorable gift.',
    },
    {
      id: 11,
      name: 'Rakitha Fernando',
      rating: 5,
      date: '2 Jan 2022',
      text: 'I am very satisfied and happy with Merch Masters. The lamp arrived exactly as I wanted. Highly recommended.',
    },
    {
      id: 12,
      name: 'Hiroshi Sasirejion',
      rating: 5,
      date: '22 Dec 2021',
      text: 'Such a great product. It looks so cute and I love it. Highly recommended.',
    },
    {
      id: 13,
      name: 'Tharushi Lakshani',
      rating: 5,
      date: '7 Dec 2021',
      text: 'I appreciate the hard work that went into this handmade night lamp. It is amazing and I love it. Thank you for the great work.',
    },
    {
      id: 14,
      name: 'Isuru UD Silva',
      rating: 5,
      date: '24 Nov 2021',
      text: 'Quality and creative product with great customer service. Absolutely loved it. Thank you.',
    },
    {
      id: 15,
      name: 'Kathija Arafath',
      rating: 5,
      date: '21 Nov 2021',
      text: 'Thank you so much. I loved the lamp and the quick turnaround. Great service and attention to privacy. I will order again.',
    },
    {
      id: 16,
      name: 'Nisara Weerasinghe',
      rating: 5,
      date: '16 Nov 2021',
      text: 'I found Merch Masters on Instagram and ordered a customized night lamp. It was awesome and very well organized work. Highly recommended.',
    },
    {
      id: 17,
      name: 'Gimhani Mendiz',
      rating: 5,
      date: '28 Oct 2021',
      text: 'Thank you so much for this awesome lamp. My friend was on cloud nine with the surprise. All credit goes to Merch Masters.',
    },
    {
      id: 18,
      name: 'Vidushi Rishika',
      rating: 5,
      date: '16 Oct 2021',
      text: 'This night lamp is a creative gift. They patiently made the changes I requested and delivered on time.',
    },
    {
      id: 19,
      name: 'Arjana Achu',
      rating: 5,
      date: '15 Oct 2021',
      text: 'The most fantastic work. Elegant results.',
    },
    {
      id: 20,
      name: 'Tharmi Alagan',
      rating: 5,
      date: '14 Oct 2021',
      text: 'This is really awesome, even better than I expected.',
    },
    {
      id: 21,
      name: 'Pavani Nisansala',
      rating: 5,
      date: '13 Oct 2021',
      text: 'The lamp came out exactly as I wanted and the customer service was the best. Friendly, kind, and considerate. Thank you for making my friend\'s day special.',
    },
    {
      id: 22,
      name: 'Dhanu Dhanushika',
      rating: 5,
      date: '13 Oct 2021',
      text: 'Worth the price and I am more than satisfied with the product. Unique gift, great work, and superb customer service. I will be back.',
    },
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const total = testimonials.length;
    const intervalId = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % total);
    }, 7000);

    return () => clearInterval(intervalId);
  }, [testimonials.length]);

  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-screen-xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 leading-tight mb-3 sm:mb-4">
            What <span className="bg-[#E85D44] text-[#FFD93D] px-4 sm:px-6 py-1 sm:py-2 inline-block">Customers</span> Saying
          </h2>
        </div>

        {/* Testimonial Card with Side Arrows */}
        <div className="relative max-w-4xl mx-auto">
          {/* Left Arrow */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-[#FFF5F2] hover:bg-[#FFE5E0] text-[#E85D44] rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-300 -ml-4 lg:-ml-16"
            aria-label="Previous testimonial"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Testimonial Card */}
          <div className="bg-[#FFF5F2] rounded-2xl shadow-xl p-8 sm:p-12 text-center relative overflow-hidden border border-gray-100">
            {/* Decorative Background Pattern */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#E85D44]/10 rounded-full -mr-16 -mt-16"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-[#FFD93D]/15 rounded-full -ml-20 -mb-20"></div>

            {/* Quote Icon */}
            <div className="relative flex justify-center mb-6">
              <div className="bg-[#E85D44]/10 rounded-full p-4">
                <svg
                  className="w-10 h-10 text-[#E85D44]"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
              </div>
            </div>

            {/* Star Rating */}
            <div className="relative flex justify-center gap-1 text-yellow-400 mb-4">
              {Array.from({ length: testimonials[currentIndex].rating }).map((_, index) => (
                <svg
                  key={index}
                  className="w-6 h-6"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M12 2l2.755 5.583 6.168.898-4.462 4.35 1.053 6.149L12 16.897l-5.514 2.983 1.053-6.149L3.076 8.48l6.169-.898L12 2z" />
                </svg>
              ))}
            </div>

            {/* Testimonial Text */}
            <p className="relative text-lg sm:text-xl md:text-2xl text-gray-700 max-w-2xl mx-auto leading-relaxed mb-6 font-light italic">
              "{testimonials[currentIndex].text}"
            </p>

            {/* Customer Info */}
            <div className="relative">
              <p className="text-lg font-bold text-gray-900 mb-1">
                {testimonials[currentIndex].name}
              </p>
              <p className="text-sm text-gray-500">{testimonials[currentIndex].date}</p>
            </div>

            {/* Progress Dots */}
            <div className="relative flex justify-center gap-2 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`transition-all duration-300 ${
                    index === currentIndex
                      ? 'w-8 h-2 bg-[#E85D44]'
                      : 'w-2 h-2 bg-gray-300 hover:bg-gray-400'
                  } rounded-full`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>

          {/* Right Arrow */}
          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-[#FFF5F2] hover:bg-[#FFE5E0] text-[#E85D44] rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-300 -mr-4 lg:-mr-16"
            aria-label="Next testimonial"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
